<template>
  <div :class="$style.container">
    <mute-toggle-button v-if="hasMuteButton" />
    <recording-button />
    <dialpad-button v-if="hasDialpad" />
    <notepad-button />
    <live-coach-chat-button />
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import MuteToggleButton from './mute-toggle-button/mute-toggle-button'
  import DialpadButton from './dialpad-button/dialpad-button'
  import NotepadButton from './notepad-button/notepad-button'
  import RecordingButton from './recording-button/recording-button'
  import LiveCoachChatButton from './live-coach-chat-button/live-coach-chat-button'

  const { mapGetters } = createNamespacedHelpers('conference')

  export default {
    components: {
      MuteToggleButton,
      DialpadButton,
      NotepadButton,
      RecordingButton,
      LiveCoachChatButton
    },
    computed: mapGetters([
      'hasDialpad',
      'hasMuteButton'
    ])
  }
</script>

<style module lang="less" src="./toolbar.less"></style>




// WEBPACK FOOTER //
// toolbar.vue?b08110fa